export default "__VITE_ASSET__BhvzwakQ__"